import { css } from '@linaria/core';
import React from 'react';
import clsx from 'clsx';
import RowIndexCellFormatter from './formatters/RowIndexCellFormatter';
import type { Column } from './types';

export const SELECT_COLUMN_KEY = 'select-row';

const selectCellClassName = css`
  &.rdg-cell.rdg-cell-frozen {
    background-color: var(--header-background-color);
    padding: 0px;
    color: var(--color);
    &:hover {
      color: var(--color) !important;
    }
  }
`;

const rowCellSelectClassName = css`
  &.rdg-cell.${selectCellClassName} {
    background-color: var(--row-hover-background-color);
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SelectColumn: Column<any, any> = {
  key: SELECT_COLUMN_KEY,
  name: '',
  width: 70,
  resizable: false,
  sortable: false,
  clickable: false,
  frozen: true,
  cellClass: (row, isRowCellSelected) => {
    return clsx(selectCellClassName, { [rowCellSelectClassName]: isRowCellSelected });
  },
  headerRenderer(_props) {
    return <div style={{ width: '100%', height: '100%' }}></div>;
  },
  formatter: RowIndexCellFormatter,
};
